import { render } from "./NetworkError.vue?vue&type=template&id=479c019c&ts=true"
import script from "./NetworkError.vue?vue&type=script&lang=ts"
export * from "./NetworkError.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__